// =====================================================================================================================
// --- User Interface ---
// =====================================================================================================================

export const SHOW_CAMERA_DENIED_DIALOG_INTERVAL_IN_MILLISECONDS = 400;
